import type { FunctionComponent, PropsWithChildren } from "react";

import Headline from "~/components/Headline";

const SidebarHeaderHeadline: FunctionComponent<PropsWithChildren> = ({ children }) => (
	<Headline type="h3">{children}</Headline>
);
export default SidebarHeaderHeadline;